import { Component, input } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MteFormatDateWrapper } from '@mortar/angular/elements/utilities/format-date';
import { DisplayComponent } from 'app/driver-pay/persistence/core/components/displays/DisplayComponent';

@Component({
  selector: 'local-date-display',
  template: `
    @if (value(); as value) {
      <mte-format-date
        id="{{ this.id() ?? value.toString() }}"
        [date]="value.toString() ?? ''"
        format="shortDate"
        timeZone="UTC" />
    }
  `,
  standalone: true,
  imports: [MtrFormFieldModule, MteFormatDateWrapper],
})
export class LocalDateDisplayComponent implements DisplayComponent {
  id = input<string>();
  value = input.required<any>();
}
